import { render, staticRenderFns } from "./PageIntro.vue?vue&type=template&id=27f9acde&scoped=true&"
import script from "./PageIntro.vue?vue&type=script&lang=js&"
export * from "./PageIntro.vue?vue&type=script&lang=js&"
import style0 from "./PageIntro.vue?vue&type=style&index=0&id=27f9acde&scoped=true&lang=css&"
import style1 from "./PageIntro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9acde",
  null
  
)

export default component.exports